import React, { useEffect, useState } from 'react';
import { Modal, Table, Spinner, Badge } from 'react-bootstrap';
import moment from 'moment-timezone';
import { Phone, ShoppingBag, DollarSign } from 'lucide-react';
import { customerAnalyticsAPI } from '../../services';

const formatCurrency = (n) =>
  new Intl.NumberFormat('vi-VN', { maximumFractionDigits: 0 }).format(n || 0);

const CustomerHistoryModal = ({ show, onHide, phone, queryParams }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!show || !phone) return;
    let cancelled = false;
    setLoading(true);
    customerAnalyticsAPI
      .getCustomerHistory(phone, queryParams)
      .then((res) => !cancelled && setData(res))
      .catch((err) => {
        console.error('[CustomerHistoryModal]', err);
        !cancelled && setData(null);
      })
      .finally(() => !cancelled && setLoading(false));
    return () => {
      cancelled = true;
    };
  }, [show, phone, queryParams]);

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <Phone size={18} className="me-2" />
          Lịch sử mua — {phone}
          {data?.customer_name && <span className="text-muted ms-2">({data.customer_name})</span>}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" size="sm" /> <span className="ms-2">Đang tải…</span>
          </div>
        ) : !data ? (
          <div className="text-center py-4 text-muted">Không có dữ liệu.</div>
        ) : (
          <>
            <div className="d-flex gap-3 mb-3 flex-wrap">
              <Badge bg="primary" className="p-2">
                <ShoppingBag size={14} className="me-1" />
                {data.total_orders} đơn
              </Badge>
              <Badge bg="success" className="p-2">
                <DollarSign size={14} className="me-1" />
                {formatCurrency(data.total_spent)} ₫
              </Badge>
              <Badge bg="info" className="p-2">
                {data.distinct_items} món khác nhau
              </Badge>
            </div>

            {data.items.length === 0 ? (
              <div className="text-center py-3 text-muted">Không có món nào trong khoảng thời gian.</div>
            ) : (
              <div className="table-responsive">
                <Table hover size="sm" className="align-middle">
                  <thead className="table-light">
                    <tr>
                      <th>Món</th>
                      <th className="text-center">Số lần</th>
                      <th className="text-center">Số lượng</th>
                      <th className="text-end">Chi tiêu</th>
                      <th>Lần đầu</th>
                      <th>Lần cuối</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.items.map((it) => (
                      <tr key={it.menu_item_id}>
                        <td>
                          <div className="fw-semibold">{it.menu_item_name}</div>
                          {it.category_name && <div className="small text-muted">{it.category_name}</div>}
                        </td>
                        <td className="text-center">
                          <Badge bg={it.purchase_count >= 3 ? 'success' : 'secondary'}>
                            {it.purchase_count}
                          </Badge>
                        </td>
                        <td className="text-center">{it.total_qty}</td>
                        <td className="text-end">{formatCurrency(it.total_spent)} ₫</td>
                        <td className="small">{it.first_purchase_at ? moment(it.first_purchase_at).format('DD/MM/YY') : '—'}</td>
                        <td className="small">{it.last_purchase_at ? moment(it.last_purchase_at).format('DD/MM/YY') : '—'}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            )}
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default CustomerHistoryModal;
